import {
  createExternalRouteRef,
  createRouteRef,
} from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();

/**
 * The template list on `/create/templates`, mounted by the override of the
 * scaffolder's `sub-page:scaffolder/templates` (see `scaffolderTemplatesModule`).
 */
export const templatesRouteRef = createRouteRef();

export const viewTechDocRouteRef = createExternalRouteRef({
  params: ['namespace', 'kind', 'name'],
  defaultTarget: 'techdocs.docRoot',
});

export const selectedTemplateRouteRef = createExternalRouteRef({
  params: ['namespace', 'templateName'],
  defaultTarget: 'scaffolder.selectedTemplate',
});

export const editTemplateRouteRef = createExternalRouteRef({
  defaultTarget: 'scaffolder.edit',
});

export const actionsTemplateRouteRef = createExternalRouteRef({
  defaultTarget: 'scaffolder.actions',
});

export const scaffolderListTaskRouteRef = createExternalRouteRef({
  defaultTarget: 'scaffolder.listTasks',
});

export const templatingExtensionsRouteRef = createExternalRouteRef({
  defaultTarget: 'scaffolder.templatingExtensions',
});

export const catalogYamlGeneratorRouteRef = createRouteRef();
